import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import RequireAuth from './features/authentication/components/RequireAuth';
import { msalInstance } from './features/authentication/services/msal';
import ACLs from './routes/acls';
import Roles from './routes/roles';
import Root from './routes/root';
import Users from './routes/users';
import { store } from './store';

import './index.css';

const router = createBrowserRouter([
  {
    children: [
      {
        element: (
          <RequireAuth>
            <Users />
          </RequireAuth>
        ),
        path: '/users',
      },
      {
        element: (
          <RequireAuth>
            <Users />
          </RequireAuth>
        ),
        path: '/users/:userId',
      },
      {
        element: (
          <RequireAuth>
            <Roles />
          </RequireAuth>
        ),
        path: '/roles',
      },
      {
        element: (
          <RequireAuth>
            <Roles />
          </RequireAuth>
        ),
        path: '/roles/:roleId',
      },
      {
        element: (
          <RequireAuth>
            <ACLs />
          </RequireAuth>
        ),
        path: '/acls',
      },
      {
        element: (
          <RequireAuth>
            <ACLs />
          </RequireAuth>
        ),
        path: '/acls/:aclId',
      },
    ],
    element: <Root />,
    path: '/',
  },
]);

// MSAL v3+ requires initialize() before any other API on the instance;
// gate the render on it because acquireAccessToken also uses the
// instance directly (outside React) in the Graph API base query
msalInstance
  .initialize()
  .then(() => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <Provider store={store}>
            <RouterProvider router={router} />
          </Provider>
        </MsalProvider>
      </React.StrictMode>
    );
  })
  .catch((error) => {
    // Without this the app fails to a silent white screen (e.g. browser
    // policies blocking crypto/storage). Surface something actionable.
    document.getElementById('root')!.textContent =
      'Failed to initialize authentication. Please reload; if this persists, contact IT Ops.';
    // eslint-disable-next-line no-console -- nothing rendered yet, console is all we have
    console.error('MSAL initialization failed:', error);
  });
